import * as types from "@/store/taxcode/types";

export default {
  [types.SET_TAXCODELIST](state, payload) {
    state.taxcodeList = payload;
  },
  [types.SET_TAXCODEMETA](state, payload) {
    state.taxcodeListMeta = {
      total: payload && payload.total != null ? Number(payload.total) : 0,
      currentPage:
        payload && payload.currentPage != null ? `${payload.currentPage}` : "1",
      perPage:
        payload && payload.perPage != null ? `${payload.perPage}` : "10",
    };
  },
  [types.SET_TAXCODEOBJECT](state, payload) {
    state.currentTaxcodeObject = payload;
  }
};
